"use client";

import BreadCrumbs from "@/components/BreadCrumbs/BreadCrumbs";
import Detailslist from "@/components/Detailslist/Detailslist";
import { blogFilter } from "@/utils/data";
import StoryCard from "../components/SuccessStories/StoryCard/StoryCard";

export default function SuccessStoriesPage({ stories = [] }) {
  const props = {
    heading: "Search accordingly your convenience",
    filterData: blogFilter,
  };

  return (
    <div>
      <BreadCrumbs />
      <Detailslist props={props}>
        {stories.map((story, i) => (
          <StoryCard key={story.id ?? i} story={story} />
        ))}
      </Detailslist>
    </div>
  );
}
